import styled from "styled-components";
import {Black} from "./colors";

export const BasicText = styled.span`
  font-style: normal;
`;

export const SmallText = styled(BasicText)`
  color: ${Black};
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.0075rem;
`;

export const Text = styled(BasicText)`
  color: ${Black};
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.00875rem;
`;

export const BigText = styled(BasicText)`
  color: ${Black};
  font-size: 1.375rem;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.01375rem;
`;

export const Title = styled(BasicText)`
  color: ${Black};
  font-size: 2.25rem;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.0675rem;
`;